module.exports = __webpack_public_path__ + "static/media/1033167.7f7e2159.jpg";